import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Paper, Typography, Alert, CircularProgress } from '@mui/material';
import ProjetoForm from '../../components/Projeto/ProjetoForm';
import { obterProposta } from '../../services/propostaService';

const SubmeterProjetoPage = () => {
  const [proposta, setProposta] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false); // Estado para sucesso
  const location = useLocation();
  const propostaId = new URLSearchParams(location.search).get('propostaId');
  
  useEffect(() => {
    const verificarProposta = async () => {
      try {
        const response = await obterProposta(propostaId);
        if (response.status !== 'APROVADA') {
          setError('Apenas propostas aprovadas podem ter projetos submetidos.');
        } else if (response.projeto) {
          setError('Esta proposta já possui um projeto submetido.');
        }
        setProposta(response);
      } catch (err) {
        setError('Erro ao verificar proposta.');
      } finally {
        setLoading(false);
      }
    };
    
    if (propostaId) {
      verificarProposta();
    } else {
      setLoading(false);
      setError('ID da proposta não fornecido.');
    }
  }, [propostaId]);

  // Função para lidar com o sucesso da submissão do projeto
  const handleSuccess = () => {
    setSuccess(true); // Atualiza o estado de sucesso
    setError(null); // Limpa qualquer erro anterior
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={4}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', p: { xs: 2, sm: 4 }, backgroundColor: '#f5f5f5' }}>
      <Box sx={{ maxWidth: 800, mx: 'auto' }}>
        <Paper sx={{ p: 4 }}>
          <Typography variant="h4" gutterBottom>
            Submeter Projeto
          </Typography>

          {/* Exibir mensagem de sucesso */}
          {success && (
            <Alert severity="success" sx={{ mt: 2, mb: 2 }}>
              Projeto submetido com sucesso!
            </Alert>
          )}

          {/* Exibir mensagem de erro */}
          {error && (
            <Alert severity="error" sx={{ mt: 2, mb: 2 }}>
              {error}
            </Alert>
          )}

          {/* Renderizar o formulário apenas se não houver erro */}
          {!error && (
            <ProjetoForm
              propostaId={propostaId}
              onSuccess={handleSuccess} // Passa a função de sucesso
            />
          )}
        </Paper>
      </Box>
    </Box>
  );
};

export default SubmeterProjetoPage;